import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	issues: {
		id: 'software-backlog-panel.common.issues-count.issues',
		defaultMessage: 'Issues',
		description: 'Count of total issues for a card on the backlog panel.',
	},
	completed: {
		id: 'software-backlog-panel.common.issues-count.completed',
		defaultMessage: 'Completed',
		description: 'Count of completed issues for a card on the backlog panel.',
	},
	issuesIssueTermRefresh: {
		id: 'software-backlog-panel.common.issues-count.issues-issue-term-refresh',
		defaultMessage: 'Work items',
		description: 'Count of total issues for a card on the backlog panel.',
	},
});
